/** @returns Euclidean distance between two points */
export const distance = (p1: { x: number; y: number }, p2: { x: number; y: number }) =>
  Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2)

/** Converts degrees to radians
 * @param deg - degrees
 */
export const deg2rad = (deg: number) => (deg * Math.PI) / 180

/** Converts radians to degrees
 * @param rad - radians
 */
export const rad2deg = (rad: number) => (rad * 180) / Math.PI
